import { Container } from "react-bootstrap"

const IotCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <h2 className="text-primary mb-3 ft-wt-700">Realtime Vehicle Telemerty</h2>
                <p>
                    In the current digital era, smart devices are exponentially growing and data-generating sensors embedded in them to monitor in real-time or near real-time. Data generated from these sensors are helpful to make business decisions by analysing the data in real time. It is clear that there is a growing need to harness and analyze IoT data. We can achieve this by integrating Information and Communication Technology (ICT) and Internet of Things (IoT) solutions in a secure fashion to improve operational efficiency.
                </p>
                <p>
                    One of the logistics companies transports flammable products using vehicle containers.
                </p>
                <p>
                    We implemented an intelligent real-time monitoring solution with Apache Kafka and Cloud in anomaly detection in multiple sensors which are installed in the vehicle. This solution monitors the temperatures of the engine and the container, GPS coordinates, speed limit in real-time and sends notifications to the admin team and driver in case of an anomaly. Drivers have a whole new automated service experience.&nbsp;
                </p>
                <p>
                    But the challenge is with poor or no internet connection during the travel of the vehicle. While a major feature of telemetry devices is that they are designed to send data in real time, when a connection is lost you could end up losing the information you need for monitoring and control purposes. The software in the gateway should mitigate this by running without connectivity. It should also use queuing of data in case this lack of connection happens for a longer period of time.
                </p>
            </Container>

        </section>
    )
}

export default IotCaseStudy